import {assignmentTypes} from "Constants/constants";
import {COPY_STRINGS} from "Constants/translatedCopy";

const introTextByActivityType = {
  [assignmentTypes.DYSLEXIA]: () => {return COPY_STRINGS.dyslexia_instructions;}, //this has to be a function because otherwise it will be evaluated before the language is set and will not work as expected for non english markets
  [assignmentTypes.NWF]: () => {return COPY_STRINGS.nwf_instructions;},
  [assignmentTypes.SPELLING]: () => {return COPY_STRINGS.spelling_intro;},
  [assignmentTypes.ASSESSMENT]: (session) => session.assessmentPageNavEnabled ? COPY_STRINGS.orf_with_page_navigation_instructions : COPY_STRINGS.orf_instructions,
  [assignmentTypes.LISTENING_COMPREHENSION]: () => {return COPY_STRINGS.listening_comprehension_intro;},
  [assignmentTypes.READING_COMPREHENSION]: () => {return COPY_STRINGS.reading_comprehension_intro;},
  [assignmentTypes.VOCABULARY_SCREENER]: () => {return COPY_STRINGS.vocabulary_screener_intro;},
};

export default function getActivityIntroText(activityType, session){
  const intro = introTextByActivityType[activityType] || introTextByActivityType[assignmentTypes.ASSESSMENT];
  return intro.bind(this, session);
}